function autoload() {
  $.each(CCL, (section, obj) => {
    if ($.isArray(obj.autoload)) {
      $.each(obj.autoload, (key, value) => {
        if ($.isArray(value)) {
          if (value[1]) {
            CCL[section][value[0]]();
          } else if (value[2]) {
            CCL[section][value[2]]();
          }
        } else {
          CCL[section][value]();
        }
      });
    }
  });
}

$(() => {
  autoload();
});



// WEBPACK FOOTER //
// ./src/js/_autoload.js